/**
 * Detects dynamic-import chunk load failures thrown by the webpack/rspack runtime.
 *
 * Both bundlers set `error.name === 'ChunkLoadError'` for failed JS chunks. CSS chunk
 * failures (mini-css/css-extract) only surface via the message, so we also match the
 * `Loading [CSS ]chunk <id> failed` text as a fallback.
 */
export const isChunkLoadError = (error: unknown): boolean => {
  if (error == null || typeof error !== 'object') {
    return false;
  }

  const { name, message } = error as { readonly name?: unknown; readonly message?: unknown };

  if (name === 'ChunkLoadError') {
    return true;
  }

  return typeof message === 'string' && /Loading (CSS )?chunk .+ failed/i.test(message);
};
